import { render, staticRenderFns } from "./cookie-modal.vue?vue&type=template&id=53cfcfb9"
import script from "./cookie-modal.vue?vue&type=script&lang=js"
export * from "./cookie-modal.vue?vue&type=script&lang=js"
import style0 from "./cookie-modal.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports